import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { tap, finalize } from 'rxjs';

import { ICurrentUser } from './interfaces';
import { MatMenuTrigger } from '@angular/material/menu'
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { GetUserMenuUseCase } from './use-cases';
import { MenuItemsModel, UserMenuResponseModel } from './models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild("dashboardMenu") dashboardMenu!: MatMenuTrigger;
  @ViewChild("referenceMenu") referenceMenu!: MatMenuTrigger;

  title = "PerformRx Pharmacy Business Intelligence";
  isAuthenticating = false;
  currentYear: number = new Date().getFullYear();
  //menuItems = [{label: "" || undefined, icon: "", route: "", url: "" || undefined}];
  menuItems : MenuItemsModel[] = [];
  
  userEmail="";
  isExists=false;
  isLoading = true;

  constructor(
    @Inject('ICurrentUser') public currentUser: ICurrentUser,
    private oauthService: OidcSecurityService,
    private router: Router, 
    private getUserMenuUseCase: GetUserMenuUseCase
  ) { }
  
   ngOnInit(): void {
    // console.log(`environment: ${environment.type}`);
    this.logIn()
      .subscribe(() => {
        this.isAuthenticating = false;
      });
  }

  getAutherization() {
    this.isLoading = true;
    this.isExists = false;
    this.getUserMenuUseCase.execute()
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe({
        next: (response: UserMenuResponseModel[]) => {
          this.menuItems = [];
          response.forEach((element) => {
              const item = {label: element.name , icon: "summarize",  route: "/tableau", url: element.url };
              this.menuItems.push(item);
              this.isExists = true;
          });
        }
      });
  }

  logInButton($event: Event) {
    $event.preventDefault();
    this.logIn()
      .subscribe(() => {
        this.isAuthenticating = false;
      });
  }

  logIn() {
    this.isAuthenticating = true;

    return this.currentUser.logIn()
      .pipe(
        tap(isLoggedIn => {
          console.log(`isLoggedIn: ${isLoggedIn}`);
          this.getAutherization();
          // console.log(`currentUser.roles: ${this.currentUser.roles}`);
        }),
        finalize(() => {
          this.isAuthenticating = false;
        })
      );
  }

  logOutButton($event: Event) {
    $event.preventDefault();
    this.currentUser.logOut().subscribe(() => {
      this.router.navigate(['/home']);
    });
  }

  navigate(tableauUrl: string)
  {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate(['/tableau'], {state: { tableauUrl: tableauUrl}});
    });
  }

  openMyMenu(type: string)
  {
    if(type == "dashboard")
      this.dashboardMenu.toggleMenu();
    else
      this.referenceMenu.toggleMenu();
  }
}
